import { AnyObject, FormState } from "final-form";
import { debounce } from "debounce";

import { storage } from "./storage";
import { LocalPersistOptions, LocalPersist } from "./types";
import { filterObject } from "./helpers";

const createLocalPersist = (options: LocalPersistOptions) => {
  const { name, blocklist = [] } = options;
  if (!name) {
    throw new Error('createLocalPersist expects a "name" option');
  }

  const clear = () => storage.remove(name);
  const setValues = <T>(values: T) => storage.set(name, values);
  const getValues = <T>(): T => storage.get(name);
  const isPersisted = () => storage.withData(name);

  const formSubscribe: LocalPersist<AnyObject>["formSubscribe"] = (_, transformValues) =>
    debounce((formState: FormState<AnyObject>) => {
      if (formState && !formState.pristine) {
        const valuesObject = filterObject<AnyObject>(formState.values, [
          ...blocklist,
          ...Object.keys(formState.errors)
        ]);
        setValues(transformValues(valuesObject));
      }
    }, 500);

  const result: LocalPersist<AnyObject> = {
    formSubscribe: formSubscribe,
    getValues,
    clear,
    isPersisted
  };

  return result;
};

export { createLocalPersist };
